import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpTextField from "@rmp/core/components/fields/RmpTextField.vue";
import { prepareEmailRule, prepareInnRule, requiredRule } from "@rmp/core/utils/validation";
import RmpMasterAccountAccessApplicationBaseStep
	from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { useI18n } from "vue-i18n-composable";
import { useMasterAccountAccessSelectCounterpartyStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectCounterparty";
import { useMasterAccountAccessContactInformationStepStore } from "@rmp/id/stores/masterAccountAccess/steps/contactInformation";
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";

export interface Props {
	readonly?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpContactInformationStep',
  props: {
    readonly: { type: Boolean }
  },
  setup(__props: any) {



const { colors } = useColors();

const { tc } = useI18n();

const useStore = useMasterAccountAccessContactInformationStepStore;
const masterAccountAccessStore = useMasterAccountAccessStore();
const store = useStore();

let {
	email,
	formValid
} = storeToRefs(store);

const {} = useStore();

const form = ref<any>(null);

const validation = {
	email: [requiredRule(), prepareEmailRule()]
};

watch(email, async (value) => {
	if(value)
		form.value.validate();
});

const { initialized } = usePage({ useStore });

return { __sfc: true,colors, tc, useStore, masterAccountAccessStore, store, email, formValid, form, validation, initialized, RmpText, RmpTextField, RmpMasterAccountAccessApplicationBaseStep }
}

})